import { QuickAlert } from "@components";
import { A } from "@solidjs/router";
import { useSubscription } from "@state/subscription";
import { Info } from "lucide-solid";
import { Match, Switch } from "solid-js";
import { useService } from "solid-services";
import { link } from "styled-system/recipes";

export default function ({ setIsOpen }: { setIsOpen: (open: boolean) => void }) {
  const { subscription, currentPeriodEnd } = useService(useSubscription)()

  return (
    <Switch>
      <Match when={subscription.data?.status === 'pending-cancel'}>
        <QuickAlert colorPalette='warning' title="Your account is pending cancellation" icon={<Info />} desc={<>
          After the {currentPeriodEnd()} your account will be cancelled, you can update your account in <A class={link()} onClick={() => setIsOpen(false)} href="/settings">Settings</A>
        </>}>
        </QuickAlert>
      </Match>
      <Match when={subscription.data?.status === 'trialing'}>
        <QuickAlert colorPalette='info' title="Your account is in trial mode" icon={<Info />} desc={<>
          you can update your membership in <A class={link()} onClick={() => setIsOpen(false)} href="/settings">Settings</A>
        </>}>
        </QuickAlert>
      </Match>
    </Switch >
  )
}
